export default __webpack_public_path__ + "static/media/amazing-race.c770d911.jpg";